import fetch from "lib/fetch";
import type { CesuCheckResponse } from "types/cesu";

export const checkCesuNumSpRequest = (num: string) =>
    fetch.get<{ data: CesuCheckResponse }>(`cesu/num_check_sp/${num}`);

export const checkCesuNumPeRequest = (num: string, birthday: string, providerCesu?: string) =>
    fetch.get<{ data: CesuCheckResponse }>(`cesu/num_check_pe/${num}/${birthday}/${providerCesu}`);

export const onlineSalaryDeclarationRequest = (bookingId: string) =>
    fetch.post<{ data: unknown }>(`cesu/online_salary_declaration/${bookingId}`);

export const activateCesuPlusRequest = (bookingId: string) =>
    fetch.post<{ data: unknown }>(`cesu/activate_cesu_plus/${bookingId}`);

export const activateAiciRequest = (bookingId: string) =>
    fetch.post<{ data: unknown }>(`cesu/activate_aici/${bookingId}`);

export const generateCesuAttestationRequest = (bookingId: string) =>
    fetch.get<{ data: unknown }>(`cesu/generate_attestation/${bookingId}`);
